<template>
    <div>
        <config-main-title> Promedsys </config-main-title>

        <div class="row mb-3">
            <div class="col col-12 col-md-9">
                <AzPeriodo v-model="filtros" :sync="true" @sync="sincronizarPeriodo" />
            </div>
            <div class="col col-12 col-md-3 d-flex flex-column">
                <button type="button" class="btn btn-outline-primary" @click="abrir_modal_executar()">
                    <i class="fas fa-play mr-1"></i> Executar
                </button>
            </div>
        </div>

        <div v-if="lista && lista_filtrada.length > 0">
            <div class="list-group mb-3 az-anime-surgir">
                <li
                    class="list-group-item list-group-item-action"
                    v-for="(log, id) in lista_filtrada"
                    :key="id"
                    @click="editar_log(log)"
                    style="cursor: pointer;"
                >
                    <div class="d-flex align-items-start">
                        <!-- Status -->
                        <div class="mr-3 mt-1" style="min-width: 90px;">
                            <span class="badge badge-pill" :class="log.fl_sucesso ? 'badge-success' : 'badge-danger'">
                                <i :class="log.fl_sucesso ? 'fas fa-check' : 'fas fa-times'"></i>
                                {{ log.fl_sucesso ? 'Sucesso' : 'Erro' }}
                            </span>
                        </div>

                        <!-- Endpoint + erro/resumo -->
                        <div class="flex-grow-1 mr-3">
                            <div class="font-weight-bold text-dark">{{ endpointExibicao(log) }}</div>
                            <div v-if="!log.fl_sucesso && log.st_erro" class="text-danger small mt-1">
                                <i class="fas fa-exclamation-circle mr-1"></i>{{ log.st_erro }}
                            </div>
                            <div v-if="resumoConsulta(log)" class="text-muted small mt-1">
                                <span class="mr-3"><i class="fas fa-inbox mr-1"></i>Recebidos: <strong>{{ resumoConsulta(log).qt_total_recebido }}</strong></span>
                                <span class="mr-3"><i class="fas fa-cogs mr-1"></i>Processados: <strong>{{ resumoConsulta(log).qt_processado }}</strong></span>
                                <span class="mr-3"><i class="fas fa-exclamation-triangle mr-1 text-warning"></i>Inconsistências: <strong>{{ qtdInconsistencias(log) }}</strong></span>
                                <span class="mr-3"><i class="fas fa-check-circle mr-1 text-success"></i>Atualizados: <strong>{{ resumoConsulta(log).qt_atualizado }}</strong></span>
                                <span v-if="resumoConsulta(log).qt_erro > 0" class="text-danger"><i class="fas fa-times-circle mr-1"></i>Erros: <strong>{{ resumoConsulta(log).qt_erro }}</strong></span>
                            </div>
                            <div v-else-if="dadosEnvio(log)" class="text-muted small mt-1">
                                <span v-if="dadosEnvio(log).guiasContidasRemessa != null" class="mr-3">
                                    <i class="fas fa-file-medical mr-1"></i>Guias: <strong>{{ dadosEnvio(log).guiasContidasRemessa }}</strong>
                                </span>
                                <span v-if="dadosEnvio(log).identificadorRemessa != null" class="mr-3">
                                    <i class="fas fa-hashtag mr-1"></i>Remessa: <strong>{{ dadosEnvio(log).identificadorRemessa }}</strong>
                                </span>
                                <span v-if="dadosEnvio(log).tokenRemessa" class="mr-3">
                                    <i class="fas fa-key mr-1"></i>Token: <strong>{{ dadosEnvio(log).tokenRemessa }}</strong>
                                </span>
                            </div>
                        </div>

                        <!-- Tipo -->
                        <div class="mr-3 mt-1 text-nowrap" style="min-width: 78px;">
                            <span
                                :class="isEnvio(log) ? 'text-warning' : 'text-info'"
                                style="font-size: 0.78rem;"
                            >
                                <i
                                    class="mr-1"
                                    :class="isEnvio(log) ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"
                                    :title="isEnvio(log) ? 'Envio' : 'Consulta'"
                                    data-toggle="tooltip"
                                    data-placement="top"
                                ></i>
                                {{ isEnvio(log) ? 'Envio' : 'Consulta' }}
                            </span>
                        </div>

                        <!-- Datas -->
                        <div class="text-right text-nowrap" style="min-width: 210px;">
                            <div
                                class="px-2 py-1 rounded"
                                :style="isEnvio(log)
                                    ? 'background-color: #fff3cd; border-left: 3px solid #ffc107;'
                                    : 'background-color: #e8f4fd; border-left: 3px solid #3a9bd5;'"
                            >
                                <div class="small text-muted">{{ isEnvio(log) ? 'Data do envio' : 'Última consulta' }}</div>
                                <div
                                    class="font-weight-bold"
                                    :style="isEnvio(log)
                                        ? 'color: #856404; font-size: 0.95rem;'
                                        : 'color: #1a6fa0; font-size: 0.95rem;'"
                                >
                                    <i class="fas fa-clock mr-1"></i>{{ formatarData(log.dt_ultima_consulta) }}
                                </div>
                            </div>
                            <div class="small text-muted mt-1">
                                <i class="fas fa-calendar-alt mr-1"></i>Criado em: {{ formatarData(log.created_at) }}
                            </div>
                        </div>
                    </div>
                </li>
            </div>
        </div>

        <div v-else>
            <az-empty-state msg="Nenhum log encontrado..." icon="fas fa-file-alt" />
        </div>

        <nav class="navbar fixed-bottom navbar-light bg-light pb-3" v-if="dados && dados.last_page > 1">
            <div class="d-flex">
                <paginate
                    class="mb-0"
                    :page-count="dados.last_page"
                    :container-class="'pagination'"
                    :page-class="'page-item'"
                    :page-link-class="'page-link'"
                    :prev-class="'page-link'"
                    :next-class="'page-link'"
                    :prev-text="'<<'"
                    :next-text="'>>'"
                    :click-handler="recarregar"
                />
            </div>
        </nav>

        <div class="modal fade" id="modalExecutarPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalExecutarPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            <i class="fas fa-play mr-2"></i>Executar Promedsys
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12">
                                <az-input
                                    label="Data e hora de execução"
                                    type="datetime-local"
                                    required
                                    :validate="validate"
                                    v-model="execucao.dt_execucao"
                                />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Cancelar
                        </button>
                        <az-submit @click="confirmar_execucao()">
                            Confirmar
                        </az-submit>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document" style="max-width: 90vw; height: 86vh;">
                <div class="modal-content" v-if="item" style="height: 100%;">
                    <div class="modal-header">
                        <h5 class="modal-title">
                            Detalhes do Log
                            <span class="badge badge-secondary ml-2"># {{ item.id_promedsys_log }}</span>
                            <span class="badge badge-pill ml-2" :class="item.fl_sucesso ? 'badge-success' : 'badge-danger'">
                                {{ item.fl_sucesso ? 'Sucesso' : 'Erro' }}
                            </span>
                            <span
                                class="ml-2"
                                :class="isEnvio(item) ? 'text-warning' : 'text-info'"
                                :title="isEnvio(item) ? 'Envio' : 'Consulta'"
                                data-toggle="tooltip"
                                data-placement="top"
                                style="font-size: 0.75rem;"
                            >
                                <i class="mr-1" :class="isEnvio(item) ? 'fas fa-arrow-up' : 'fas fa-arrow-down'"></i>
                                {{ isEnvio(item) ? 'Envio' : 'Consulta' }}
                            </span>
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <!-- Cabeçalho fixo -->
                        <div class="row mb-3">
                            <div class="col col-12 col-md-6">
                                <label class="text-muted small mb-0">Endpoint</label>
                                <div class="font-weight-bold">{{ endpointExibicao(item) }}</div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <label class="text-muted small mb-0">Criado em</label>
                                <div>{{ formatarData(item.created_at) }}</div>
                            </div>
                            <div class="col col-12 col-md-3">
                                <label class="text-muted small mb-0">{{ isEnvio(item) ? 'Data do envio' : 'Última consulta' }}</label>
                                <div class="font-weight-bold">{{ formatarData(item.dt_ultima_consulta) }}</div>
                            </div>
                        </div>

                        <div v-if="!item.fl_sucesso && item.st_erro" class="alert alert-danger mb-3">
                            <i class="fas fa-exclamation-circle mr-2"></i>{{ item.st_erro }}
                        </div>

                        <div v-if="resumoConsulta(item)" class="d-flex flex-wrap mb-3">
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Total recebido: <strong>{{ resumoConsulta(item).qt_total_recebido }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Processados: <strong>{{ resumoConsulta(item).qt_processado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Inconsistências: <strong>{{ qtdInconsistencias(item) }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Encontrados: <strong>{{ resumoConsulta(item).qt_encontrado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Atualizados: <strong>{{ resumoConsulta(item).qt_atualizado }}</strong>
                            </span>
                            <span class="badge badge-light border mr-2 mb-2 p-2">
                                Erros: <strong>{{ resumoConsulta(item).qt_erro }}</strong>
                            </span>
                        </div>
                        <div v-else-if="dadosEnvio(item)" class="d-flex flex-wrap mb-3">
                            <span v-if="dadosEnvio(item).guiasContidasRemessa != null" class="badge badge-light border mr-2 mb-2 p-2">
                                Guias na remessa: <strong>{{ dadosEnvio(item).guiasContidasRemessa }}</strong>
                            </span>
                            <span v-if="dadosEnvio(item).identificadorRemessa != null" class="badge badge-light border mr-2 mb-2 p-2">
                                Identificador da remessa: <strong>{{ dadosEnvio(item).identificadorRemessa }}</strong>
                            </span>
                            <span v-if="dadosEnvio(item).tokenRemessa" class="badge badge-light border mr-2 mb-2 p-2">
                                Token da remessa: <strong>{{ dadosEnvio(item).tokenRemessa }}</strong>
                            </span>
                            <span v-if="dadosEnvio(item).dataHoraRegistroRemessa" class="badge badge-light border mr-2 mb-2 p-2">
                                Registro da remessa: <strong>{{ formatarData(dadosEnvio(item).dataHoraRegistroRemessa) }}</strong>
                            </span>
                        </div>

                        <!-- Abas -->
                        <ul class="nav nav-tabs" role="tablist">
                            <li class="nav-item">
                                <a class="nav-link active" id="tab-req-res" data-toggle="tab" href="#pane-req-res" role="tab">Request / Response</a>
                            </li>
                            <li class="nav-item">
                                <a class="nav-link" id="tab-data" data-toggle="tab" href="#pane-data" role="tab">Dados</a>
                            </li>
                            <li v-if="!isEnvio(item)" class="nav-item">
                                <a class="nav-link" id="tab-atualizadas" data-toggle="tab" href="#pane-atualizadas" role="tab">Guias atualizadas</a>
                            </li>
                            <li v-if="!isEnvio(item)" class="nav-item">
                                <a class="nav-link" id="tab-nao-encontradas" data-toggle="tab" href="#pane-nao-encontradas" role="tab">Guias não encontradas</a>
                            </li>
                            <li v-if="!isEnvio(item)" class="nav-item">
                                <a class="nav-link" id="tab-inconsistencias" data-toggle="tab" href="#pane-inconsistencias" role="tab">Guias com inconsistências</a>
                            </li>
                            <li v-if="!isEnvio(item)" class="nav-item">
                                <a class="nav-link" id="tab-erros" data-toggle="tab" href="#pane-erros" role="tab">Guias com erro</a>
                            </li>
                            <li v-if="isEnvio(item)" class="nav-item">
                                <a class="nav-link" id="tab-guias-enviadas" data-toggle="tab" href="#pane-guias-enviadas" role="tab">Guias enviadas</a>
                            </li>
                        </ul>

                        <div class="tab-content pt-3">
                            <!-- Aba Request / Response -->
                            <div class="tab-pane fade show active" id="pane-req-res" role="tabpanel">
                                <div class="row">
                                    <div class="col col-12 col-md-6">
                                        <label class="text-muted small mb-1">Request</label>
                                        <pre class="bg-light p-2 rounded small" style="max-height: calc(90vh - 280px); overflow-y: auto;">{{ formatarJson(item.js_request) }}</pre>
                                    </div>
                                    <div class="col col-12 col-md-6">
                                        <label class="text-muted small mb-1">Response</label>
                                        <pre class="bg-light p-2 rounded small" style="max-height: calc(90vh - 280px); overflow-y: auto;">{{ formatarJson(item.js_response) }}</pre>
                                    </div>
                                </div>
                            </div>

                            <!-- Aba Dados (js_data) -->
                            <div class="tab-pane fade" id="pane-data" role="tabpanel">
                                <div class="mb-2">
                                    <az-input
                                        label="Pesquisar no JSON"
                                        v-model="buscaJsonDados"
                                        placeholder="Pesquisar..."
                                    />
                                    <div v-if="buscaJsonDados" class="small text-muted mt-1">
                                        {{ contarOcorrenciasJson(item.js_data, buscaJsonDados) }} ocorrência(s) encontrada(s)
                                    </div>
                                </div>
                                <pre class="bg-light p-2 rounded small" style="max-height: calc(90vh - 280px); overflow-y: auto;" v-html="formatarJsonComBusca(item.js_data, buscaJsonDados)"></pre>
                            </div>

                            <div v-if="!isEnvio(item)" class="tab-pane fade" id="pane-atualizadas" role="tabpanel">
                                <div v-if="guiasAtualizadas(item).length" class="table-responsive" style="max-height: calc(90vh - 280px); overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>N. guia prestador</th>
                                                <th>N. guia operadora</th>
                                                <th>Operadora</th>
                                                <th>Paciente</th>
                                                <th>ID atendimento</th>
                                                <th>Status</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(guia, index) in guiasAtualizadas(item)" :key="`atualizada-${index}`">
                                                <td>{{ campoGuia(guia, 'numeroContaPrestador') || '-' }}</td>
                                                <td>{{ numeroGuiaPrestador(guia) || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'numeroGuiaOperadora') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'nome_operadora') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'nome_paciente') || '-' }}</td>
                                                <td>{{ formatarIdAtendimento(campoGuia(guia, 'id_atendimento')) }}</td>
                                                <td>{{ guia.status || '-' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <az-empty-state v-else msg="Nenhuma guia atualizada encontrada." icon="fas fa-file-medical" />
                            </div>

                            <div v-if="!isEnvio(item)" class="tab-pane fade" id="pane-nao-encontradas" role="tabpanel">
                                <div v-if="guiasNaoEncontradas(item).length" class="table-responsive" style="max-height: calc(90vh - 280px); overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>N. conta prestador</th>
                                                <th>N. guia prestador</th>
                                                <th>N. guia operadora</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(guia, index) in guiasNaoEncontradas(item)" :key="`nao-encontrada-${index}`">
                                                <td>{{ campoGuia(guia, 'numeroContaPrestador') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'numeroGuiaPrestador') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'numeroGuiaOperadora') || '-' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <az-empty-state v-else msg="Nenhuma guia não encontrada." icon="fas fa-search" />
                            </div>

                            <div v-if="!isEnvio(item)" class="tab-pane fade" id="pane-inconsistencias" role="tabpanel">
                                <div v-if="guiasInconsistencia(item).length" class="table-responsive" style="max-height: calc(90vh - 280px); overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>N. guia prestador</th>
                                                <th>N. guia operadora</th>
                                                <th>Operadora</th>
                                                <th>Paciente</th>
                                                <th>ID atendimento</th>
                                                <th>Status</th>
                                                <th>Erro</th>
                                                <th class="text-right">Acoes</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(guia, index) in guiasInconsistencia(item)" :key="`inconsistencia-${index}`">
                                                <td>{{ campoGuia(guia, 'numeroContaPrestador') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'numeroGuiaPrestador') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'numeroGuiaOperadora') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'nome_operadora') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'nome_paciente') || '-' }}</td>
                                                <td>{{ formatarIdAtendimento(campoGuia(guia, 'id_atendimento')) }}</td>
                                                <td>{{ guia.status || '-' }}</td>
                                                <td>{{ guia.erro || '-' }}</td>
                                                <td class="text-right">
                                                    <button type="button" class="btn btn-outline-primary btn-sm" @click="abrirModalInconsistencia(guia)">
                                                        Detalhes
                                                    </button>
                                                </td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <az-empty-state v-else msg="Nenhuma guia com inconsistencias." icon="fas fa-exclamation-triangle" />
                            </div>

                            <div v-if="!isEnvio(item)" class="tab-pane fade" id="pane-erros" role="tabpanel">
                                <div v-if="guiasErros(item).length" class="table-responsive" style="max-height: calc(90vh - 280px); overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>Id</th>
                                                <th>N. guia prestador</th>
                                                <th>N. guia operadora</th>
                                                <th>Operadora</th>
                                                <th>Paciente</th>
                                                <th>ID atendimento</th>
                                                <th>Status</th>
                                                <th>Erro</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(guia, index) in guiasErros(item)" :key="`erro-${index}`">
                                                <td>{{ campoGuia(guia, 'numeroContaPrestador') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'numeroGuiaPrestador') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'numeroGuiaOperadora') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'nome_operadora') || '-' }}</td>
                                                <td>{{ campoGuia(guia, 'nome_paciente') || '-' }}</td>
                                                <td>{{ formatarIdAtendimento(campoGuia(guia, 'id_atendimento')) }}</td>
                                                <td>{{ guia.status || '-' }}</td>
                                                <td>{{ guia.erro || '-' }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <az-empty-state v-else msg="Nenhuma guia com erro encontrada." icon="fas fa-check-circle" />
                            </div>

                            <div v-if="isEnvio(item)" class="tab-pane fade" id="pane-guias-enviadas" role="tabpanel">
                                <div v-if="guiasEnviadas(item).length" class="table-responsive" style="max-height: calc(90vh - 280px); overflow-y: auto;">
                                    <table class="table table-sm table-hover bg-white">
                                        <thead>
                                            <tr>
                                                <th>N. guia prestador</th>
                                                <th>N. conta prestador</th>
                                                <th>Paciente</th>
                                                <th>Medico</th>
                                                <th>Qtd. procedimentos</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <tr v-for="(guia, index) in guiasEnviadas(item)" :key="`guia-enviada-${index}`">
                                                <td>{{ guia.numeroGuiaPrestador || '-' }}</td>
                                                <td>{{ guia.numeroContaPrestador || '-' }}</td>
                                                <td>{{ guia.dadosPaciente && guia.dadosPaciente.nomePaciente ? guia.dadosPaciente.nomePaciente : '-' }}</td>
                                                <td>{{ nomeMedicoGuia(guia) }}</td>
                                                <td>{{ quantidadeProcedimentosGuia(guia) }}</td>
                                            </tr>
                                        </tbody>
                                    </table>
                                </div>
                                <az-empty-state v-else msg="Nenhuma guia enviada encontrada na request." icon="fas fa-paper-plane" />
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>

        <div class="modal fade" id="modalInconsistenciaPromedSys" tabindex="-1" role="dialog"
            aria-labelledby="modalInconsistenciaPromedSysTitleId" aria-hidden="true">
            <div class="modal-dialog modal-lg modal-dialog-scrollable" role="document" style="max-width: 74vw;">
                <div class="modal-content">
                    <div class="modal-header" style="background-color: #f8f9fa; border-bottom: 1px solid #eceff3;">
                        <h5 class="modal-title">
                            Detalhe da inconsistência
                        </h5>
                        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                            <span aria-hidden="true">&times;</span>
                        </button>
                    </div>
                    <div class="modal-body">
                        <div class="row">
                            <div class="col col-12 col-md-6 mb-3 mb-md-0">
                                <label class="text-muted small mb-1">Guia correspondente na response</label>
                                <pre class="bg-light p-2 rounded small mb-0" style="max-height: 500px; overflow-y: scroll;">{{ formatarJson(guiaResponseSelecionada) }}</pre>
                            </div>
                            <div class="col col-12 col-md-6">
                                <label class="text-muted small mb-1">Detalhe da inconsistência</label>
                                <pre class="bg-light p-2 rounded small mb-0" style="max-height: 500px; overflow-y: scroll;">{{ formatarJson(inconsistenciaSelecionada) }}</pre>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">
                            Fechar
                        </button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import ConfigMainTitle from "../../cadastros/shared/ConfigMainTitle.vue";
import AzInput from "../../shared/forms/AzInput.vue";
import AzPeriodo from "../../shared/forms/AzPeriodo.vue";
import AzSubmit from "../../util/AzSubmit.vue";

export default {
    components: {
        ConfigMainTitle,
        AzInput,
        AzPeriodo,
        AzSubmit,
    },

    data() {
        return {
            dados: {
                data: [],
                last_page: 0,
            },
            lista: [],
            filtros: {
                page: 1,
                size: 20,
                periodo: '',
                inicio: null,
                fim: null,
            },
            bloqueia_sync_periodo: true,
            item: null,
            execucao: {
                dt_execucao: null,
            },
            inconsistenciaSelecionada: null,
            guiaResponseSelecionada: null,
            buscaJsonDados: "",
            validate: false,
        };
    },

    computed: {
        lista_filtrada: function () {
            return this.lista || [];
        },
    },

    methods: {
        obterJsonCampo(log, campo) {
            const valor = log && log[campo] ? log[campo] : null;
            if (!valor) return null;

            if (typeof valor === "string") {
                try {
                    return JSON.parse(valor);
                } catch {
                    return null;
                }
            }

            return valor;
        },

        obterJsData(log) {
            return this.obterJsonCampo(log, "js_data");
        },

        obterJsResponse(log) {
            return this.obterJsonCampo(log, "js_response");
        },

        obterJsRequest(log) {
            return this.obterJsonCampo(log, "js_request");
        },

        resumoConsulta(log) {
            const jsData = this.obterJsData(log);
            if (jsData && jsData.resumo) return jsData.resumo;

            const jsResponse = this.obterJsResponse(log);
            return jsResponse && jsResponse.resumo ? jsResponse.resumo : null;
        },

        qtdInconsistencias(log) {
            const resumo = this.resumoConsulta(log);

            if (resumo && resumo.qt_inconsistencia != null) {
                return resumo.qt_inconsistencia;
            }

            return this.guiasInconsistencia(log).length;
        },

        guiasAtualizadas(log) {
            const jsData = this.obterJsData(log);
            if (jsData && Array.isArray(jsData.guias_atualizadas)) return jsData.guias_atualizadas;
            return jsData && Array.isArray(jsData.detalhes) ? jsData.detalhes : [];
        },

        guiasNaoEncontradas(log) {
            const jsData = this.obterJsData(log);
            return jsData && Array.isArray(jsData.guias_nao_encontradas) ? jsData.guias_nao_encontradas : [];
        },

        guiasInconsistencia(log) {
            const jsData = this.obterJsData(log);
            return jsData && Array.isArray(jsData.guias_inconsistencia) ? jsData.guias_inconsistencia : [];
        },

        guiasErros(log) {
            const jsData = this.obterJsData(log);
            if (jsData && Array.isArray(jsData.guias_erros)) return jsData.guias_erros;
            return [];
        },

        campoGuia(guia, campo) {
            if (!guia) return null;

            if (guia[campo] != null) return guia[campo];
            if (guia.dados && guia.dados[campo] != null) return guia.dados[campo];

            return null;
        },

        numeroGuiaPrestador(guia) {
            return this.campoGuia(guia, "numeroGuiaPrestador") || this.campoGuia(guia, "numeroGuia");
        },

        formatarIdAtendimento(idAtendimento) {
            return idAtendimento != null && idAtendimento !== "" ? `#${idAtendimento}` : "-";
        },

        guiasEnviadas(log) {
            const jsRequest = this.obterJsRequest(log);
            return jsRequest && Array.isArray(jsRequest.guias) ? jsRequest.guias : [];
        },

        guiasResponse(log) {
            const jsResponse = this.obterJsResponse(log);
            if (!jsResponse) return [];

            if (Array.isArray(jsResponse)) return jsResponse;
            if (Array.isArray(jsResponse.guias)) return jsResponse.guias;
            if (Array.isArray(jsResponse.data)) return jsResponse.data;
            if (jsResponse.data && Array.isArray(jsResponse.data.guias)) return jsResponse.data.guias;
            if (Array.isArray(jsResponse.dados)) return jsResponse.dados;
            if (jsResponse.dados && Array.isArray(jsResponse.dados.guias)) return jsResponse.dados.guias;

            return [];
        },

        valoresEquivalentes(valorA, valorB, permitirPrefixo = false) {
            const normalizar = (valor) => (valor == null ? "" : String(valor).trim());
            const a = normalizar(valorA);
            const b = normalizar(valorB);

            if (!a || !b) return false;
            if (a === b) return true;

            if (!permitirPrefixo) return false;

            const minimoPrefixo = 6;
            if (a.length >= minimoPrefixo && b.length >= minimoPrefixo) {
                return a.startsWith(b) || b.startsWith(a);
            }

            return false;
        },

        nomeMedicoGuia(guia) {
            if (!guia) return "-";

            if (guia.dadosProfissionalExecutante && guia.dadosProfissionalExecutante.nomeProfissional) {
                return guia.dadosProfissionalExecutante.nomeProfissional;
            }

            if (guia.dadosProfissionalSolicitante && guia.dadosProfissionalSolicitante.nomeProfissional) {
                return guia.dadosProfissionalSolicitante.nomeProfissional;
            }

            return "-";
        },

        quantidadeProcedimentosGuia(guia) {
            return guia && Array.isArray(guia.procedimentosExames) ? guia.procedimentosExames.length : 0;
        },

        dadosEnvio(log) {
            const jsData = this.obterJsData(log);
            const jsResponse = this.obterJsResponse(log);

            const origem = [jsResponse, jsData].find((payload) => !!payload);
            if (!origem) return null;

            const possuiDadosRemessa =
                origem.tokenRemessa ||
                origem.identificadorRemessa != null ||
                origem.guiasContidasRemessa != null ||
                origem.dataHoraRegistroRemessa;

            return possuiDadosRemessa ? origem : null;
        },

        isEnvio(log) {
            if (!log) return false;

            const jsData = this.obterJsData(log);

            if (jsData && jsData.envio) return true;
            if (this.dadosEnvio(log)) return true;

            return !!(log.st_endpoint && /\/protocolo(\/|$)/i.test(String(log.st_endpoint)));
        },

        endpointExibicao(log) {
            if (!log || !log.st_endpoint) return "-";

            const endpoint = String(log.st_endpoint);
            if (!this.isEnvio(log)) return endpoint;

            const identificador =
                this.dadosEnvio(log) && this.dadosEnvio(log).identificadorRemessa != null
                    ? String(this.dadosEnvio(log).identificadorRemessa)
                    : "";

            if (!identificador) return endpoint;

            const endpointSemBarraFinal = endpoint.replace(/\/$/, "");

            if (/\/protocolo(\/|$)/i.test(endpointSemBarraFinal) && !endpointSemBarraFinal.endsWith("/" + identificador)) {
                return `${endpointSemBarraFinal}/${identificador}`;
            }

            return endpoint;
        },

        carregar(page = 1) {
            this.filtros.page = page;

            this.$util.load(this, {
                service: "promedsys_logs",
                parms: {
                    page: this.filtros.page,
                    size: this.filtros.size,
                    dt_inicio: this.filtros.inicio,
                    dt_fim: this.filtros.fim,
                },
                loadTo: (res) => {
                    const payload = this.normalizar_paginacao(res);
                    this.dados = payload.dados;
                    this.lista = payload.lista;

                    if (page > 1 && this.dados && this.dados.last_page && page > this.dados.last_page) {
                        this.carregar(1);
                    }
                },
            });
        },

        recarregar(page = 1) {
            this.carregar(page);
        },

        sincronizarPeriodo() {
            if (this.bloqueia_sync_periodo) return;
            this.recarregar(1);
        },

        normalizar_paginacao(res) {
            if (Array.isArray(res)) {
                return {
                    dados: {
                        data: res,
                        last_page: 1,
                    },
                    lista: res,
                };
            }

            if (res && Array.isArray(res.data)) {
                return {
                    dados: res,
                    lista: res.data,
                };
            }

            if (res && res.data && Array.isArray(res.data.data)) {
                return {
                    dados: res.data,
                    lista: res.data.data,
                };
            }

            if (res && res.data && res.data.lista && Array.isArray(res.data.lista.data)) {
                return {
                    dados: res.data.lista,
                    lista: res.data.lista.data,
                };
            }

            return {
                dados: {
                    data: [],
                    last_page: 0,
                },
                lista: [],
            };
        },

        abrir_modal_executar() {
            this.validate = false;
            this.execucao = { dt_execucao: null };
            this.$nextTick(() => {
                $("#modalExecutarPromedSys").modal("show");
            });
        },

        confirmar_execucao() {
            this.validate = true;
            if (!this.execucao.dt_execucao) return;

            this.$util.atualizar(this, {
                service: "campanhas",
                func: "executar_agora_promedsys",
                modal: "modalExecutarPromedSys",
                dados: {
                    dt_ultima_execucao: this.execucao.dt_execucao,
                },
                toast: true,
                msg: "Execução iniciada com sucesso.",
                callback: () => {
                    this.carregar();
                },
            });
        },

        editar_log(log) {
            this.item = log;
            this.buscaJsonDados = "";
            this.inconsistenciaSelecionada = null;
            this.guiaResponseSelecionada = null;
            this.$nextTick(() => {
                $("#modalInconsistenciaPromedSys").modal("hide");
                $("#modalPromedSys").modal("show");
                $('#tab-req-res').tab('show');
            });
        },

        abrirModalInconsistencia(guia) {
            this.inconsistenciaSelecionada = guia;
            this.guiaResponseSelecionada = this.obterGuiaResponsePorInconsistencia(guia);
            this.$nextTick(() => {
                $("#modalInconsistenciaPromedSys").modal("show");
            });
        },

        obterGuiaResponsePorInconsistencia(guiaInconsistencia) {
            if (!this.item || !guiaInconsistencia) return null;

            const guiasResponse = this.guiasResponse(this.item);
            if (!Array.isArray(guiasResponse) || !guiasResponse.length) return null;

            const normalizar = (valor) => (valor == null ? "" : String(valor).trim());

            const candidatosPrestador = [
                this.campoGuia(guiaInconsistencia, "numeroGuiaPrestador"),
                this.campoGuia(guiaInconsistencia, "numeroGuia"),
            ]
                .filter((v) => v != null && v !== "")
                .map(normalizar);

            const candidatosContaPrestador = [
                this.campoGuia(guiaInconsistencia, "numeroContaPrestador"),
            ]
                .filter((v) => v != null && v !== "")
                .map(normalizar);

            const candidatosOperadora = [
                this.campoGuia(guiaInconsistencia, "numeroGuiaOperadora"),
            ]
                .filter((v) => v != null && v !== "")
                .map(normalizar);

            const candidatosId = [
                this.campoGuia(guiaInconsistencia, "id_guia"),
            ]
                .filter((v) => v != null && v !== "")
                .map(normalizar);

            const matchPrincipal = guiasResponse.find((guiaResponse) => {
                const guiaPrestadorResponse = normalizar(guiaResponse.numeroGuiaPrestador || guiaResponse.numeroGuia);
                const contaPrestadorResponse = normalizar(guiaResponse.numeroContaPrestador);
                const guiaOperadoraResponse = normalizar(guiaResponse.numeroGuiaOperadora);
                const idGuiaResponse = normalizar(guiaResponse.id);

                const batePrestador =
                    candidatosPrestador.length > 0 &&
                    candidatosPrestador.some((v) => this.valoresEquivalentes(v, guiaPrestadorResponse, true));

                const bateContaPrestador =
                    candidatosContaPrestador.length > 0 &&
                    candidatosContaPrestador.some((v) => this.valoresEquivalentes(v, contaPrestadorResponse));

                const bateOperadora =
                    candidatosOperadora.length > 0 &&
                    candidatosOperadora.some((v) => this.valoresEquivalentes(v, guiaOperadoraResponse, true));

                const bateId =
                    candidatosId.length > 0 &&
                    candidatosId.some((v) => this.valoresEquivalentes(v, idGuiaResponse));

                if (batePrestador && (bateContaPrestador || bateOperadora)) return true;
                if (!candidatosPrestador.length && bateContaPrestador && bateOperadora) return true;
                if (bateId && (bateContaPrestador || batePrestador || bateOperadora)) return true;

                return false;
            });

            if (matchPrincipal) return matchPrincipal;

            const matchFallback = guiasResponse.find((guiaResponse) => {
                const contaPrestadorResponse = normalizar(guiaResponse.numeroContaPrestador);
                const guiaOperadoraResponse = normalizar(guiaResponse.numeroGuiaOperadora);
                const guiaPrestadorResponse = normalizar(guiaResponse.numeroGuiaPrestador || guiaResponse.numeroGuia);

                const bateContaPrestador =
                    candidatosContaPrestador.length > 0 &&
                    candidatosContaPrestador.some((v) => this.valoresEquivalentes(v, contaPrestadorResponse));

                const bateOperadora =
                    candidatosOperadora.length > 0 &&
                    candidatosOperadora.some((v) => this.valoresEquivalentes(v, guiaOperadoraResponse, true));

                const batePrestador =
                    candidatosPrestador.length > 0 &&
                    candidatosPrestador.some((v) => this.valoresEquivalentes(v, guiaPrestadorResponse, true));

                return bateContaPrestador || bateOperadora || batePrestador;
            });

            return matchFallback || null;
        },

        formatarData(valor) {
            if (!valor) return "-";
            const d = new Date(valor.replace(" ", "T"));
            if (isNaN(d)) return valor;
            return d.toLocaleString("pt-BR", {
                day: "2-digit",
                month: "2-digit",
                year: "numeric",
                hour: "2-digit",
                minute: "2-digit",
            });
        },

        formatarJson(valor) {
            if (!valor) return "-";
            try {
                const obj = typeof valor === "string" ? JSON.parse(valor) : valor;
                return JSON.stringify(obj, null, 2);
            } catch {
                return valor;
            }
        },

        escapeHtml(valor) {
            if (valor == null) return "";

            return String(valor)
                .replace(/&/g, "&amp;")
                .replace(/</g, "&lt;")
                .replace(/>/g, "&gt;")
                .replace(/"/g, "&quot;")
                .replace(/'/g, "&#39;");
        },

        escaparRegex(valor) {
            return valor.replace(/[.*+?^${}()|[\]\\]/g, "\\$&");
        },

        formatarJsonComBusca(valor, busca) {
            const jsonFormatado = this.formatarJson(valor);
            const jsonEscapado = this.escapeHtml(jsonFormatado);

            if (!busca) return jsonEscapado;

            const regex = new RegExp(`(${this.escaparRegex(this.escapeHtml(busca))})`, "gi");
            return jsonEscapado.replace(regex, '<mark class="px-1">$1</mark>');
        },

        contarOcorrenciasJson(valor, busca) {
            if (!busca) return 0;

            const jsonFormatado = this.formatarJson(valor);
            const ocorrencias = jsonFormatado.match(new RegExp(this.escaparRegex(busca), "gi"));

            return ocorrencias ? ocorrencias.length : 0;
        },

        formatarDataFiltro(data) {
            if (!data) return null;
            const ano = data.getFullYear();
            const mes = String(data.getMonth() + 1).padStart(2, "0");
            const dia = String(data.getDate()).padStart(2, "0");
            return `${ano}-${mes}-${dia}`;
        },

        definirPeriodoPadrao() {
            const hoje = new Date();
            const inicio = new Date(hoje.getFullYear(), hoje.getMonth(), 1);
            const fim = new Date(hoje.getFullYear(), hoje.getMonth() + 1, 0);

            this.filtros = {
                ...this.filtros,
                inicio: this.formatarDataFiltro(inicio),
                fim: this.formatarDataFiltro(fim),
            };
        },
    },

    mounted() {
        this.definirPeriodoPadrao();
        this.$nextTick(() => {
            this.bloqueia_sync_periodo = false;
            this.carregar(1);
        });

        this.breadcrumb = [
            { name: "Configurações", path: "/cadastros" },
            { name: "Logs Promedsys", path: "" },
        ];

        this.$store.commit("setBreadcrumb", this.breadcrumb);
    },
};
</script>
